module.exports = __webpack_public_path__ + "static/media/Algeria.35e0d43b.png";